/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { fg } from '@atlassian/jira-feature-gating';

type CloudId = string;

export const canFetchForgeModules = ({
	isAnonymous,
	cloudId,
}: {
	isAnonymous: boolean;
	cloudId: CloudId;
}): boolean => {
	/**
	 * SMT-1142
	 * A tenant named `bob` is most likely a local/ci instance started with `./jmake run ci`.
	 * It wasn't possible to find the hostname in a reasonable timeframe so this is the most feasible solution.
	 * In case more tenants like this spawn in the future we'd need to mark these instances instead and block here.
	 */
	if (String(cloudId) === 'bob') return false;

	/**
	 * Similarly to the `bob` tenant situation above, we don't want to fetch Forge modules on monolith webdriver tests,
	 * that are also started with `./jmake run ci`, but this time with a valid `cloudId`.
	 * The reason for that is the heartbeat service that is not available in there, which leads to the login page redirects.
	 */
	if (!__SERVER__ && getLocationHostname().endsWith('.atl-test.space')) return false;

	// Allow anonymous access for Forge modules when the respective feature gate is enabled
	if (
		isAnonymous &&
		(fg('forge_anonymous_access_for_jira_custom_fields') ||
			fg('forge_anonymous_access_for_jira_issue_panels'))
	) {
		return true;
	}

	// There is no anonymous access for now
	return !isAnonymous;
};

// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const getLocationHostname = (): string => window.location.hostname;
